// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { User } from '../../../types/user'
import type { PropertyError } from '../../../types/validation-result'
import type { Module } from 'vuex'

export type UserState = {
  user: ?User,
  userValidationErrors: PropertyError[],
  error: ?Error,
  token: ?string
}
const state: UserState = {
  user: null,
  error: null,
  userValidationErrors: [],
  token: null
}

export type UserModule = Module<UserState>

const userModule: UserModule = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default userModule



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js